import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Accordion, Card, Button } from 'react-bootstrap';
import { actionCreators } from '../actions/globalAction';
import { Loader } from '../components/solar/Loader';
import { pvbill } from '../components/objects/pvBill';


class PvbillClass extends Component {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.state = { currentItemId: [], PvbillUI:[] };
        this.showMore = this.showMore.bind(this);
    }

    toggle(id) {
        const currentItemId = [...this.state.currentItemId];

        const idx = currentItemId.indexOf(id);
        if (idx >= 0)
            currentItemId.splice(idx, 1);
        else
            currentItemId.push(id);

        this.setState({ currentItemId });
    }

    showMore() {
        let PvbillUI = this.props.PvbillUI.ZaehlerText;
        let Year = new Date().getFullYear();
        for (let i = 0; i < PvbillUI.length; i++) {
            if (PvbillUI[i].Year < Year)
                Year = PvbillUI[i].Year;
        }

        Year = Year - 1;

        this.setState({ PvbillUI });

        pvbill.PvBillClass.url = pvbill.PvBillClass.defaultSegment + "/pv/" + Year;
        pvbill.PvBillClass.forceRefresh = true;
        this.props.request(pvbill["PvBillClass"]);
    }

    componentDidMount() {
        const Year = parseInt(this.props.match.params.Year) || 0;

        if (Year > 0) {
            pvbill.PvBillClass.url = pvbill.PvBillClass.defaultSegment + "/pv/" + Year;
            pvbill.PvBillClass.forceRefresh = true;
        }
        else {
            pvbill.PvBillClass.url = pvbill.PvBillClass.defaultSegment + "/pv/" + new Date().getFullYear();
        }

        // This method runs when the component is first added to the page
        for (var k in pvbill) {
            this.props.request(pvbill[k]);
        }
    }


    render() {

        let PvbillUI = this.props.PvbillUI.ZaehlerText || {}
        let PvbillZaehlerTextUI = this.props.PvbillUI || {}
        let PvbillUIState = this.state.PvbillUI || {};
        let megaheadline = this.props.PvbillUI.MegaHeadline || {};
        let dataPv = [];

        if (typeof (PvbillUI) !== 'undefined' && PvbillUI.length > 0) {
            if (typeof (PvbillUIState) !== 'undefined' && PvbillUIState.length > 0) {
                let count = PvbillUIState.length;

                for (let i = 0; i < count; i++) {
                    let currYear = PvbillUIState[i].Year;
                    let dontaddit = false;

                    for (let a = 0; a < PvbillUI.length; a++) {
                        let thisYear = PvbillUI[a].Year;

                        if (currYear === thisYear)
                            dontaddit = true;
                    }
                    if (!dontaddit)
                        PvbillUI.push(PvbillUIState[i]);
                }
            }

            for (let a = 0; a < PvbillUI.length; a++) {
                let evudata = PvbillUI[a];
                let data = [];

                for (let i = 0; i < evudata.SubHeadline.length; i++) {
                    let dataTemp = {
                        SubHeadline: evudata.SubHeadline[i],
                        PanelContent: evudata.PanelContent[i],
                        PanelContentGesamtText: evudata.PanelContentGesamtText[i]
                    };

                    data.push(dataTemp);
                }

                let PvbillUI2 = {
                    MegaHeadline: evudata.MegaHeadline,
                    subdata: data
                };

                dataPv.push(PvbillUI2);
            }
        }

        return (
            <div>
                <div dangerouslySetInnerHTML={{ __html: megaheadline }} />
                {
                    dataPv.reverse().map((_pvdata, row) =>
                        <div>
                            <div dangerouslySetInnerHTML={{ __html: _pvdata.MegaHeadline }} />
                            {
                                _pvdata.subdata.reverse().map((_data, index) =>
                                    <div>
                                        <Loader show={!this.props.isLoaded} />
                                        <Button variant="info" onClick={() => this.toggle(index)} style={{ width: '100%', textAlign: 'left' }} dangerouslySetInnerHTML={{ __html: _data.SubHeadline }}></Button>
                                        <Accordion.Collapse in={this.state.currentItemId.includes(index)}>
                                            <Card className="mb-0">
                                                <Card.Body>
                                                    <div dangerouslySetInnerHTML={{ __html: _data.PanelContentGesamtText }} />
                                                    <div dangerouslySetInnerHTML={{ __html: _data.PanelContent }} />
                                                </Card.Body>
                                            </Card>
                                        </Accordion.Collapse>
                                    </div>)
                            }
                        </div>
                    )}
                <p>
                    <Button className="btn btn-primary" style={{ width: '100%' }} onClick={() => this.showMore()} >Show more</Button>.
                </p>
            </div>
        );
    }
}


export default connect(
    state => state.pvbillReducer,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(PvbillClass);